import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UsersManagementStore } from '../store/users-management.store';
import { of, tap } from 'rxjs';
import { RolesManagementStore } from '../../roles-management/store/roles-management.store';

export const usersManagementResolver: ResolveFn<boolean> = () => {
  const userStore = inject(UsersManagementStore);
  const roleStore = inject(RolesManagementStore);

  return of(true).pipe(
    tap(() => {
      userStore.loadUsers();
      userStore.loadPendingUsers();
      userStore.clearFilters('roleFilter');
      userStore.clearSearch();
      roleStore.loadRoles();
    }),
  );
};
